import classNames from "classnames";
import { includes, isEmpty } from "lodash";
import { useState } from "react";
import StarComponent from "./star";
import Icon from "@assets/icon_config";
import { formatDisplayDate } from "@utils/helpers";

const List = (props: {
  lastUpdatedDate: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
  description: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined;
  name: string;
  handleClick: React.MouseEventHandler<HTMLDivElement> | undefined;
  type: string;
  starred: any;
  searchedKeyWord: string;
  reportValue: any;
  updateReport: any;
}) => {
  const [isHovering, setIsHovering] = useState(false);

  let str1 = props.name;
  let str2 = "";
  let str3 = "";

  const name = props.name?.toLowerCase();
  const word = props.searchedKeyWord?.toLowerCase();

  if (includes(name, word)) {
    const index = name.indexOf(word);
    const lastIndex = index + word?.length;

    str1 = props.name.substring(0, index);
    str2 = props.name.substring(lastIndex, props.name.length);
    str3 = props.name.substring(index, lastIndex);
  }

  const nameClassName = classNames("ui-dashboard-list__footer__name", {
    "ui-dashboard-list__footer__name--not-bold": !isEmpty(props.searchedKeyWord),
  });

  return (
    <div className="ui-dashboard-list" onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} onClick={props.handleClick}>
      <div className="ui-dashboard-list__footer">
        <div className="ui-dashboard-list__footer__icon"><Icon name={props.type === "Report" ? "report-with-background" : "dashboard-with-background"} stroke={ isHovering ? "#7793D9" : undefined } /></div>
        <div className={nameClassName}>
          {str1}
          <span className="ui-dashboard-list__footer__name--bold">{str3}</span>
          {str2}
        </div>
      </div>
      {!isHovering ? (
        <div className="ui-dashboard-list__content">
          <div className="ui-dashboard-list__content__last-updated">
            {`Last updated on `}<span className="ui-dashboard-list__content__last-updated__bold">{!props.lastUpdatedDate ? `NA` : formatDisplayDate(props.lastUpdatedDate, "createDateFormat")}</span>
          </div>
          <div className="ui-dashboard-list__content__star">
            <StarComponent starred={props.starred} reportValue={props.reportValue} className="ui-dashboard-list__content__bookmark" starFilledSize={15} starOutlinedSize={15} update={props.updateReport}/>
          </div>
        </div>
      ) : (
        <div className="ui-dashboard-list__hovered">
          <div className="ui-dashboard-list__hovered__description">{props.description}</div>
          <div className="ui-dashboard-list__hovered__star">
            <StarComponent starred={props.starred} reportValue={props.reportValue} className="ui-dashboard-list__content__bookmark" starFilledSize={15} starOutlinedSize={15} update={props.updateReport}/>
          </div>
        </div>
      )}
    </div>
  );
};

export default List;
